export default __webpack_public_path__ + "static/media/14.73047b97.jpg";